<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Visits</li>
  </app-tabs>
  <div class="flex-control flex-column" *ngIf="_visitService.isFilterLoaded()" [hidden]="tabs_service.is_active()">
    <app-visits-filters class="flex-header pb0"></app-visits-filters>
    <app-visits-listing class="flex-body scroll-browser"></app-visits-listing>
  </div>
</div>
